import React from "react";
import ListEditor from "../ListEditor";
import { adminApi } from "../../lib/api";
import { Label, TextInput, TextArea, NumberInput, Switch, TagEditor, BulletEditor, ImageUploader } from "../FormControls";

const newExp = () => ({
  company: "",
  role: "",
  employment_type: "Full-time",
  location: "",
  period: "",
  start_date: "",
  end_date: "",
  current: false,
  company_logo: "",
  description: "",
  highlights: [],
  responsibilities: [],
  achievements: [],
  tags: [],
  color: "cyan",
  visible: true,
  order: 0,
});

const Experience = () => (
  <ListEditor
    resource={adminApi.experiences}
    resourceKey="experience"
    title="Experience"
    description="Work history rendered as a vertical timeline."
    newItem={newExp}
    searchFields={["company", "role"]}
    renderRow={(e) => (
      <div className="min-w-0">
        <div className="text-white font-medium truncate">
          {e.role || "Untitled role"} <span className="text-slate-500 font-normal">· {e.company}</span>
        </div>
        <div className="text-xs text-slate-500 truncate">
          {e.period} · {e.location}
        </div>
      </div>
    )}
    renderForm={(d, set) => (
      <>
        <div className="grid sm:grid-cols-2 gap-3">
          <div>
            <Label>Company</Label>
            <TextInput value={d.company} onChange={(v) => set("company", v)} />
          </div>
          <div>
            <Label>Role</Label>
            <TextInput value={d.role} onChange={(v) => set("role", v)} />
          </div>
        </div>
        <div className="grid sm:grid-cols-3 gap-3">
          <div>
            <Label>Employment Type</Label>
            <TextInput value={d.employment_type} onChange={(v) => set("employment_type", v)} />
          </div>
          <div>
            <Label>Location</Label>
            <TextInput value={d.location} onChange={(v) => set("location", v)} />
          </div>
          <div>
            <Label>Period</Label>
            <TextInput value={d.period} onChange={(v) => set("period", v)} placeholder="Jun 2025 — Present" />
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          <div>
            <Label>Start date</Label>
            <TextInput value={d.start_date} onChange={(v) => set("start_date", v)} placeholder="2025-06" />
          </div>
          <div>
            <Label>End date</Label>
            <TextInput value={d.end_date} onChange={(v) => set("end_date", v)} placeholder="Present" />
          </div>
        </div>
        <Switch value={d.current} onChange={(v) => set("current", v)} label="I currently work here" />
        <div>
          <Label>Company logo</Label>
          <ImageUploader value={d.company_logo} onChange={(v) => set("company_logo", v)} />
        </div>
        <div>
          <Label>Description</Label>
          <TextArea value={d.description} onChange={(v) => set("description", v)} rows={3} />
        </div>
        <div>
          <Label>Highlights / responsibilities</Label>
          <BulletEditor value={d.highlights} onChange={(v) => set("highlights", v)} placeholder="Add highlight" />
        </div>
        <div>
          <Label>Achievements</Label>
          <BulletEditor value={d.achievements} onChange={(v) => set("achievements", v)} placeholder="Add achievement" />
        </div>
        <div>
          <Label>Technologies / tags</Label>
          <TagEditor value={d.tags} onChange={(v) => set("tags", v)} />
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          <div>
            <Label>Accent color</Label>
            <TextInput value={d.color} onChange={(v) => set("color", v)} placeholder="cyan | violet" />
          </div>
          <div>
            <Label>Order</Label>
            <NumberInput value={d.order} onChange={(v) => set("order", v)} />
          </div>
        </div>
        <Switch value={d.visible} onChange={(v) => set("visible", v)} label="Visible on site" />
      </>
    )}
  />
);

export default Experience;
